import { multiLanguageHeader } from '@/utils/languageHeader';

// 官网后端匿名接口封装（无登录）
const BASE = (import.meta.env.VITE_API_BASE as string) || "";

export interface AnonymousBaziDetailResult {
  fourPillars?: any;
  wuxing?: any;
  rizhu?: any;
  personality?: any;
  traitTags?: any;
  traitSummary?: any;
  shishen?: any;
  shensha?: any;
  shenshaSummary?: any;
  geju?: any;
  xiyong?: any;
  dayun?: any;
  liunian?: {
    current?: any;
    /** 10 年简化流年表（当前大运起 10 年，字段 year/tianGan/diZhi/tianGanShen/diZhiShen/tianGanColor/diZhiColor/isHighlight） */
    items?: Array<{
      year: number;
      tianGan: string;
      diZhi: string;
      tianGanShen: string;
      diZhiShen: string;
      tianGanShiShen?: string;
      diZhiMainShiShen?: string;
      tianGanColor?: string;
      diZhiColor?: string;
      isHighlight?: boolean;
      shenSha?: string[];
      liuYueList?: AnonymousLiuYueItem[];
    }>;
  };
  commercialReport?: any;
}

export interface AnonymousBaziDetailParams {
  birthTime: string; // yyyy-MM-dd HH:mm
  gender: "male" | "female";
  birthPlace?: string;
  tz?: string;
  date?: string;
  lang?: string;
}

export async function fetchAnonymousBaziDetail(
  params: AnonymousBaziDetailParams,
): Promise<AnonymousBaziDetailResult> {
  const q = new URLSearchParams();
  q.set("birthTime", params.birthTime);
  q.set("gender", params.gender);
  if (params.birthPlace) q.set("birthPlace", params.birthPlace);
  if (params.tz) q.set("tz", params.tz);
  if (params.date) q.set("date", params.date);
  if (params.lang) q.set("lang", params.lang);
  const res = await fetch(`${BASE}/api/mingli/baziDetail/anonymous?${q.toString()}`, {
    headers: { Accept: "application/json", ...multiLanguageHeader() },
  });
  const json = await res.json().catch(() => null);
  if (json?.data) return json.data;
  throw new Error(json?.message || json?.msg || `八字详批接口失败（HTTP ${res.status}）`);
}

export interface AnonymousPaipanResult {
  info?: any;
  basic?: {
    daYun?: AnonymousTransitItem[];
    liuNian?: AnonymousTransitItem[];
    liuNianGroups?: AnonymousTransitItem[][];
    qiYunInfo?: string;
    jiaoYunInfo?: string;
    startAge?: number;
    startMonths?: number;
    preciseJiaoYear?: number;
    preciseJiaoMonth?: number;
    isForward?: boolean;
    mingGong?: any;
  };
  pro?: any;
}

export interface AnonymousLiuYueItem {
  monthIndex: number;
  ganzhi: string;
  tianGan: string;
  diZhi: string;
  tianGanShen?: string;
  diZhiShen?: string;
  tianGanShiShen?: string;
  diZhiMainShiShen?: string;
  tianGanColor?: string;
  diZhiColor?: string;
}

export interface AnonymousTransitItem {
  startYear?: number;
  endYear?: number;
  ageRange?: string;
  ageRange_en?: string;
  year?: number;
  tianGan: string;
  diZhi: string;
  tianGanShen?: string;
  diZhiShen?: string;
  tianGanShiShen?: string;
  diZhiMainShiShen?: string;
  tianGanColor?: string;
  diZhiColor?: string;
  isActive?: boolean;
  isHighlight?: boolean;
  shenSha?: string[];
  liuYueList?: AnonymousLiuYueItem[];
}

export interface AnonymousPaipanParams {
  birthTime: string; // yyyy-MM-dd HH:mm
  gender: "male" | "female";
  birthPlace?: string;
  tz?: string;
  date?: string;
  lang?: string;
}

export async function fetchAnonymousPaipan(
  params: AnonymousPaipanParams,
): Promise<AnonymousPaipanResult> {
  const q = new URLSearchParams();
  q.set("birthTime", params.birthTime);
  q.set("gender", params.gender);
  if (params.birthPlace) q.set("birthPlace", params.birthPlace);
  if (params.tz) q.set("tz", params.tz);
  if (params.date) q.set("date", params.date);
  if (params.lang) q.set("lang", params.lang);
  const res = await fetch(`${BASE}/api/mingli/fortune/paipan/anonymous?${q.toString()}`, {
    headers: { Accept: "application/json", ...multiLanguageHeader() },
  });
  const json = await res.json().catch(() => null);
  if (json?.data?.paipan) return json.data.paipan;
  throw new Error(json?.message || json?.msg || `排盘接口失败（HTTP ${res.status}）`);
}
